export default {
  accessToken: null
}
